import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import MediaItem from '../../components/UI/MediaItem';
import MediaUploadForm from '../../components/Forms/MediaUploadForm';
import MediaItemEditForm from '../../components/Forms/MediaItemEditForm';
import MediaConfirmDelete from '../../components/Forms/MediaConfirmDelete';
import {GetFileType} from '../../helpers/Helpers';
import {classNamesPrefixed} from '../../../helpers/CoreHelpers';

class MediaList extends Component {
    static propTypes = {
        filterMediaTypeEnabled: PropTypes.bool,
        filteredMediaType: PropTypes.string,
        filteredWorkspace: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        filteredKeyword: PropTypes.string,
        maxSelectItems: PropTypes.number,
        editEnabled: PropTypes.bool,
        deleteEnabled: PropTypes.bool,
        selectEnabled: PropTypes.bool
    };

    filterMedia() {

        const {filteredWorkspace, filteredMediaType, filteredKeyword, media} = this.props;

        let x, y, z = null;
        let filteredMediaItems = [];

        let mediaItems = media.items;

        if (!mediaItems || mediaItems.length === 0) {
            return [];
        }

        if (!filteredKeyword && !filteredMediaType && !filteredWorkspace) {
            return mediaItems
        }

        //------------filter by type
        if (filteredMediaType && mediaItems) {

            for (x in mediaItems) {

                if (GetFileType(mediaItems[x].fileName).id === filteredMediaType) {
                    filteredMediaItems.push(mediaItems[x]);
                }
            }
            mediaItems = filteredMediaItems;
        }


        //-------------filter by workspace
        filteredMediaItems = [];

        if (filteredWorkspace && mediaItems) {
            for (x in mediaItems) {
                if (mediaItems[x].workspaceId && mediaItems[x].workspaceId === filteredWorkspace) {
                    filteredMediaItems.push(mediaItems[x]);
                }
            }
            mediaItems = filteredMediaItems;
        }


        //-------------filter by search keyword
        filteredMediaItems = [];

        let allText = "";
        let keywordsMatched = [];

        if (mediaItems && filteredKeyword && filteredKeyword.length > 0) {
            let searchKeywords = filteredKeyword.toLowerCase().split(" ");

            for (x in mediaItems) {
                allText = "";

                if (mediaItems[x].title) {
                    allText += mediaItems[x].title.toLowerCase() + " ";
                }

                if (mediaItems[x].description) {
                    allText += mediaItems[x].description.toLowerCase() + " ";
                }

                if (mediaItems[x].fileName) {
                    allText += mediaItems[x].fileName.toLowerCase() + " ";
                }

                allText.replace("-", " ");
                allText.replace("_", " ");
                allText.replace(".", " ");
                allText = allText.split(" ");

                if (allText.length) {
                    keywordsMatched = [];

                    for (y in allText) {
                        for (z in searchKeywords) {
                            if (allText[y].indexOf(searchKeywords[z]) > -1) {
                                if (keywordsMatched[z]) {
                                    keywordsMatched[z]++;
                                } else {
                                    keywordsMatched[z] = 1;
                                }
                            }

                            if (keywordsMatched.length === searchKeywords.length) {
                                break;
                            }
                        }

                        if (keywordsMatched.length === searchKeywords.length) {
                            filteredMediaItems.push(mediaItems[x]);
                            break;
                        }
                    }
                }
            }
            mediaItems = filteredMediaItems;
        }

        return mediaItems;
    }

    closeMediaUploadPopup(event) {
        this.props.hideUploadModal();
    }

    render() {
        const {media, deleteEnabled, editEnabled, selectEnabled, maxSelectItems, clickableThumbnail} = this.props;
        const mediaProps = this.filterMedia();
        const {submitting} = media;

        return (
            <Fragment>
                {mediaProps.length > 0 && !submitting &&
                <div
                    className={classNamesPrefixed({
                        'media-items-wrapper': true,
                    })}
                >
                    <div
                        className={classNamesPrefixed({
                            'media-items': true,
                        })}
                    >
                        {mediaProps.map((item) => (
                            <MediaItem
                                item={item}
                                key={item.id}
                                editEnabled={editEnabled}
                                deleteEnabled={deleteEnabled}
                                selectEnabled={selectEnabled}
                                maxSelectItems={maxSelectItems}
                                clickableThumbnail={clickableThumbnail}
                            />
                        ))}
                    </div>
                </div>
                }
                {mediaProps.length === 0 &&
                <p>
                    No items...
                </p>
                }
                <MediaUploadForm
                    show={mediaProps.showMediaUploadModal}
                    onClose={(event) => this.closeMediaUploadPopup(event)}
                />
                <MediaConfirmDelete media={media}/>
                {media.editItemId &&
                <MediaItemEditForm id={media.editItemId} media={media}/>
                }
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        media: state.media,
        workspace: state.workspace
    };
};

export default connect(mapStateToProps)(MediaList)


// WEBPACK FOOTER //
// ./src/core/admin/components/UI/MediaList.js